import { useLocation, useNavigate } from "react-router-dom";

export const useOpenTerms = () => {
  const location = useLocation();
  const nav = useNavigate();

  return () => {
    const urlParams = new URLSearchParams(location.search);
    const newUrl = location.pathname + "?" + urlParams.toString();
    nav(newUrl, { state: { ...location.state, showTerms: true } });
  };
};
